/* eslint-disable */
import axios from 'axios';
import gql from 'graphql-tag';
import getMaintenanceMode from '../../utilities';
import Logger from '../../logger';

const graphql = require('graphql');
const { print } = graphql;

interface SessionDetails {
    correlationId: string;
    brand: string;
    country: string;
    source: string;
    language: string;
}

interface UnlinkAccountPayload {
    partyId: number;
    vwfsToken: string;
    sessionDetails: SessionDetails;
}

const gqlRequest = gql`
  mutation DeleteCustomerLinked($Request: DeleteBrandAndFSLinkRequest!) {
    deleteCustomerLinked(Request: $Request) {
      IsSuccess
      Errors {
        ErrorCode
        ErrorMessage
        ErrorStack
      }
    }
  }
`;

export const unlinkAccount = async (payload: UnlinkAccountPayload) => {
    const { partyId, vwfsToken, sessionDetails } = payload;

    try {
        const getMode = await getMaintenanceMode();

        if (getMode) {
            Logger.info(
                'unlinkAccount: service in maintenance mode',
                'Location ==> unlinkAccount service',
                sessionDetails,
            );

            return {
                data: {
                    inMaintenance: 'Y',
                },
            };
        }

        const appsyncUrl = process.env.REACT_APP_APPSYNC_URL ?? '';
        const url = `${appsyncUrl}/customerauth/authenticated/graphql`;

        Logger.info(
            `unlinkAccount: unlink request initiated | ${JSON.stringify({
                partyId,
                correlationId: sessionDetails.correlationId,
            })}`,
            'Location ==> unlinkAccount service',
            sessionDetails,
        );

        const response = await axios({
            url,
            method: 'post',
            headers: {
                'x-api-key': process.env.REACT_APP_API_KEY,
                Authorization: vwfsToken,
            },
            data: {
                query: print(gqlRequest),
                variables: {
                    Request: {
                        Link: {
                            PartyId: partyId,
                            Brand: sessionDetails.brand,
                            Country: sessionDetails.country,
                            Source: sessionDetails.source,
                        },
                        CorrelationId: sessionDetails.correlationId,
                    },
                },
            },
        });

        if (response?.data?.errors?.length > 0) {
            Logger.error(
                `unlinkAccount: GraphQL error | ${JSON.stringify(response.data.errors)}`,
                'Location ==> unlinkAccount service',
                JSON.stringify(response.data.errors),
                sessionDetails,
            );

            return {
                data: {
                    isSuccess: false,
                    error:
                        response.data.errors[0]?.message ||
                        'Unable to unlink account. Please try again.',
                },
            };
        }

        if (response?.data?.data?.deleteCustomerLinked?.IsSuccess) {
            Logger.info(
                'unlinkAccount: account successfully unlinked',
                'Location ==> unlinkAccount service',
                sessionDetails,
            );

            return {
                data: {
                    isSuccess: true,
                },
            };
        }

        const errorMessage =
            response?.data?.data?.deleteCustomerLinked?.Errors?.[0]?.ErrorMessage ||
            'Unable to unlink account. Please try again.';

        return {
            data: {
                isSuccess: false,
                error: errorMessage,
            },
        };
    } catch (error) {
        Logger.error(
            'unlinkAccount: exception occurred',
            'Location ==> unlinkAccount service',
            error as string,
            sessionDetails,
        );

        return { error };
    }
};